//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfLoader from "~/themes/fiskarsMoominDefault/components/components/atoms/SfLoader/SfLoader.vue";
import SfProductCard from "~/themes/fiskarsMoominDefault/components/components/organisms/SfProductCard/SfProductCard.vue";
import {
  computed,
  ref,
  defineComponent,
  watch,
  onBeforeUnmount,
  useContext,
  onMounted,
  toRef,
} from "@nuxtjs/composition-api";
import { onSSR } from "@vue-storefront/core";
import {
  coveoGetters,
  useCoveoHeadlessProductListing,
  useCoveoAdvancedQuery
} from "~/composables";
import LazyHydrate from "vue-lazy-hydration";
import CategoryHeader from "~/components/Category/CategoryHeader";
import CategoryFilters from "~/components/Category/CategoryFilters.vue";
import InfiniteLoading from "vue-infinite-loading";
import coveoMethods from "~/helpers/coveoMethods";
import { getCMSItem, showingOfProductsTitle } from "~/helpers/globalLabels";
import {
  loadSearchAnalyticsActions,
  loadSearchActions,
  loadClickAnalyticsActions,
  loadAdvancedSearchQueryActions
} from "@coveo/headless";
import { getCMSLabels } from "~/helpers/globalLabels";
import { sortingOptions } from "~/helpers/sortingOptions";
import { coveoFacetsProperties } from "~/common";

export default defineComponent({
  name: "MoominProductListing",
  transition: "fade",
  components: {
    SfLoader,
    LazyHydrate,
    CategoryHeader,
    CategoryFilters,
    SfProductCard,
    InfiniteLoading,
  },
  props: {
    collectionMapping: {
      type: Object,
    },
    categoryMapping: {
      type: Object,
    },
    classification_occasion: {
      type: Object,
    },
    classification_material: {
      type: Object,
    },
    classification_size: {
      type: Object,
    },
    classification_character: {
      type: Object,
    },
    facets: {
      type: [Object, Array],
      default: () => [],
    },
    sorting: {
      type: Object,
    },
    itemsPerPage: {
      type: Number,
    },
    labels: Object,
    image: Object,
  },
  setup(props) {
    const { i18n } = useContext();
    const infiniteLoadingEvent = ref(null);
    const hasMoreProducts = ref(true);
    const {
      engine,
      resultList,
      facets: headlessFacets,
      sort,
      buildSortingObject,
    } = useCoveoHeadlessProductListing();

    const productsList = ref([]);
    const totalCountFilteredProducts = ref(0);
    const loadingProducts = ref(false);
    const facets = ref([]);

    const {
      advancedQuery,
      advancedQueries,
      catAdvancedQuery,
      collectionsAdvancedQuery,
      classOccasionAdvancedQuery,
      classMaterialAdvancedQuery,
      classSizeAdvancedQuery,
      classCharacterAdvancedQuery,
    } = useCoveoAdvancedQuery({
      categoryMapping: toRef(props, 'categoryMapping'),
      collectionMapping: toRef(props, 'collectionMapping'),
      classification_occasion: toRef(props, 'classification_occasion'),
      classification_material: toRef(props, 'classification_material'),
      classification_size: toRef(props, 'classification_size'),
      classification_character: toRef(props, 'classification_character'),
    });

    const facetArgs = computed(() => {
      return coveoMethods.refineFacetArgs(props.facets);
    });

    let unsubscribeEngine;
    let unsubscribeResultList;

    const { logInterfaceLoad } = loadSearchAnalyticsActions(engine);
    const { executeSearch } = loadSearchActions(engine);

    const initSearch = async () => {
      await engine.dispatch(loadAdvancedSearchQueryActions(engine).updateAdvancedSearchQueries({aq: advancedQuery.value}));
      await engine
        .dispatch(executeSearch(logInterfaceLoad()));
    };

    unsubscribeEngine = engine.subscribe(() => {
      loadingProducts.value = engine?.state?.search?.isLoading;
      facets.value = coveoGetters.getFacets(engine?.state?.search?.response);
      totalCountFilteredProducts.value =
        engine?.state?.search?.response?.totalCountFiltered;
    });

    unsubscribeResultList = resultList.subscribe(() => {
      hasMoreProducts.value = resultList?.state.moreResultsAvailable;
      productsList.value = coveoGetters.getFilteredProducts(resultList.state);
      if(process.server && productsList.value.length > 0){
          unsubscribeEngine();
          unsubscribeResultList();
        }
      if (infiniteLoadingEvent.value) {
        infiniteLoadingEvent.value?.loaded();
      }
    });

    onSSR(async () => {
      await initSearch();
    });

    onMounted(() => {
      initSearch();
    })

    watch(advancedQuery, async () => {
      await initSearch();
    });

    const selectedFilters = computed(() => {
      let result = [];
      facets.value.forEach((facet) => {
        facet.value.forEach((value) => {
          if (value.value && value.state === "selected") {
            result.push({
              facetId: facet.facetId,
              selected: true,
              state: value.state,
              label: value.value,
            });
          }
        });
      });
      return result;
    });



    const sendClickEventToCoveo = async (product) => {

      const { logDocumentOpen } = loadClickAnalyticsActions(engine);
      await engine.dispatch(logDocumentOpen(product.coveoData));

    };

    const offset = ref(productsList.value?.length || 0);

    const facetProperties = coveoFacetsProperties.map((property) => {
      return {
        ...property,
        displayName: i18n.t(property.displayName),
      };
    });


    const sortingProperties = computed(() => {
      let sortProp = [];

      sortingOptions.forEach((option) => {
        const sortObj = {
          displayName: i18n.t(option.labelKey),
          ...option
        }
        sortProp.push(sortObj);
      });

      return sortProp;
    });

    const selectedOptionRef = ref(sortingProperties?.value[0]?.displayName);

    const facetItems = computed(() =>
      coveoGetters.getFacetItems(facets.value, facetProperties)
    );

    const filters = computed(() =>
      coveoGetters.getFacetItems(facets.value, facetProperties)
    );


    const getMoreProducts = async (event) => {
      infiniteLoadingEvent.value = event;

      if (!loadingProducts.value) {
        resultList.fetchMoreResults();

        if (!hasMoreProducts.value) {
          event.complete();
        }
      }
    };

    const loadMoreFacetItems = (facetID, moreItemsAvailble) => {
      const facet = headlessFacets.value.find(
        (facet) => facet.state.facetId === facetID
      );
      moreItemsAvailble ? facet.showMoreValues() : facet.showLessValues();
    };

    const handleApplyFilter = (filter) => {
      const facet = headlessFacets.value.find(
        (facet) => facet.state.facetId === filter.facetId
      );
      const facetValue = facet.state.values.find(
        (value) => value.value === filter.label
      );

      let selection = {
        value: facetValue.value,
        numberOfResults: facetValue.numberOfResults,
      };

      // make facet item checked
      if (
        selectedFilters.value?.findIndex(
          (item) => filter.label === item.label
        ) < 0
      ) {
        filter.selected = true;

        selection = {
          ...selection,
          state: "selected",
        };
      } else {
        // make facet item un-checked
        filter.selected = false;

        selection = {
          ...selection,
          state: "idle",
        };
      }

      facet.toggleSelect(selection);
    };

    const handleClearAllFilters = async () => {
      headlessFacets.value.forEach((facet) => {
        if (facet?.state?.values?.some((value) => value.state === "selected")) {
          facet.deselectAll();
        }
      });
    };

    const initiateSorting = async (selectedOption) => {
      sort.sortBy(
        buildSortingObject(
          selectedOption.sortBy,
          selectedOption.sortOrder,
          selectedOption.sortField
        )
      );
      selectedOptionRef.value = selectedOption.displayName;
    };


    const _filtersLabel = computed(() => getCMSLabels('filters'));

    onBeforeUnmount(() => {
      engine.dispatch(loadAdvancedSearchQueryActions(engine).updateAdvancedSearchQueries({aq: ''}));
      handleClearAllFilters();
      if (unsubscribeEngine) {
        unsubscribeEngine();
      }
      if (unsubscribeResultList) {
        unsubscribeResultList();
      }
    });

    const getBadgeColor = () => {
      return getCMSItem('badge-color-discount-percentage') || "#FBAFA0";
    }

    return {
      getBadgeColor,
      _filtersLabel,
      getCMSLabels,
      handleApplyFilter,
      handleClearAllFilters,
      initiateSorting,
      productsList,
      selectedFilters,
      getMoreProducts,
      hasMoreProducts,
      offset,
      sortingProperties,
      facetItems,
      coveoGetters,
      filters,
      facetArgs,
      totalCountFilteredProducts,
      initSearch,
      showingOfProductsTitle,
      loadMoreFacetItems,
      sendClickEventToCoveo,
      selectedOptionRef
    };
  },
});
